import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },
}));

export default function CustomDialogTitle(props) {
  const classes = useStyles();
  const { title } = props;
  return (
    <DialogTitle id="alert-dialog-title" className={classes.title}>
      <b>{title}</b>
    </DialogTitle>
  );
}
